import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL

function getAccessToken() {
  return localStorage.getItem('user-token')
}

axios.interceptors.request.use((request) => {
  request.headers['Authorization'] = 'Bearer ' + getAccessToken()
  return request
})

const refreshAuthLogic = (failedRequest) =>
  axios.post('/auth/refresh').then((tokenRefreshResponse) => {
    const token = tokenRefreshResponse.data.token
    localStorage.setItem('user-token', token)
    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token
    return Promise.resolve()
  })

function createAuthRefreshInterceptor(axios, refreshTokenCall, options = {}) {
  const id = axios.interceptors.response.use(
    (res) => res,
    (error) => {
      // console.log('axios start response')
      // Reject promise if the error status is not in options.ports or defaults.ports
      const statusCodes =
        options.hasOwnProperty('statusCodes') && options.statusCodes.length
          ? options.statusCodes
          : defaults.statusCodes
      if (
        !error.response ||
        (error.response.status && statusCodes.indexOf(+error.response.status) === -1)
      ) {
        return Promise.reject(error)
      }

      if (error.request.responseURL.includes('auth/login')) {
        const data = error.response.data
        const e = Error(data.message)
        if (data.detail) {
          e.message = `${data.message}. ${data.detail}`
        }
        return Promise.reject(e)
      }
      // Remove the interceptor to prevent a loop
      // in case token refresh also causes the 401
      axios.interceptors.response.eject(id)

      const refreshCall = refreshTokenCall(error)

      // Create interceptor that will bind all the others requests
      // until refreshTokenCall is resolved
      const requestQueueInterceptorId = axios.interceptors.request.use((request) =>
        refreshCall.then(() => request)
      )

      // When response code is 401 (Unauthorized), try to refresh the token.
      return refreshCall
        .then(() => {
          axios.interceptors.request.eject(requestQueueInterceptorId)
          return axios(error.response.config)
        })
        .catch((err) => {
          axios.interceptors.request.eject(requestQueueInterceptorId)
          localStorage.removeItem('user-token')
          axios.router.push({ name: 'login' })
          return Promise.reject(err)
        })
        .finally(() => createAuthRefreshInterceptor(axios, refreshTokenCall, options))
    }
  )
  return axios
}

export default createAuthRefreshInterceptor(axios, refreshAuthLogic, { statusCodes: [401, 403] })
